import StudioModal from '@/components/modals/StudioModal.vue';
import { Component } from 'vue-property-decorator';
import { EModalName } from '@/helpers/modal';
import { Button } from 'streamlabs-beaker';
import { ITransition } from '@/helpers/transition';
import EditorBase from '../EditorBase';
import TransitionApi from '@/apis/transition-api';
import { ESocketEvent } from '@/helpers/socket';
import { EAnalyticsEvent } from '@/helpers/analytic';

@Component({
  components: {
    StudioModal,
    SButton: Button,
  },
})
export default class TransitionLibraryMixins extends EditorBase {
  previewTransition: ITransition = null;
  previewTransitionPlaying: boolean = false;

  get modalName(): string {
    return EModalName.transitionLibrary;
  }

  hideModal() {
    this.resetModal();
    this.$modal.hide(this.modalName);
  }

  get title(): string {
    return this.previewTransition ? this.previewTransition.name : 'Add a Transition';
  }

  async mounted() {
    if (!this.availableTransitions) {
      const transitionResponse = await TransitionApi.getTransitions();
      if (transitionResponse.transitions) this.availableTransitions = transitionResponse.transitions;
    }
  }

  resetModal() {
    this.previewTransition = null;
  }

  setPreviewTransition(transition: ITransition) {
    this.previewTransition = transition;
  }

  async addTransition(transition: ITransition) {
    this.selectedProject = { ...this.selectedProject, ...{ scene_transition_id: transition.id, scene_transition: transition } };
    await this.saveProject(false);

    this.$socket.client.emit(ESocketEvent.updateTransition, transition);
    this.$sla.sendEvent(EAnalyticsEvent.transitionAdded, { id: transition.id });
    this.hideModal();
  }

  async onPreviewApply() {
    await this.addTransition(this.previewTransition);
    this.hideModal();
  }

  setPreviewTransitionPlaying(previewTransitionPlaying: boolean) {
    this.previewTransitionPlaying = previewTransitionPlaying;
  }
}
